module.exports = __webpack_public_path__ + "img/customPreviewView.b24468a0.png";